var map = {
	"./translation_de-eu.json": 77153,
	"./translation_de.json": 4813,
	"./translation_en-gb.json": 95585,
	"./translation_en.json": 19489,
	"./translation_fr.json": 78970,
	"./translation_it.json": 82115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46241;